import React, { Fragment } from "react";
import LayoutOne from "../layouts/LayoutOne";
import Titles from '../components/Titles'
import WhyChooseUs from '../components/WhyChooseUs'
import Video from '../components/Video'
import GalleryShort from '../components/Gallery/GalleryShort';
import Skill from '../components/Skill';
import Seo from '../components/Seo';
import { getSiteLocation } from '../helpers/siteLocation';

const Home = () => {
  const { type, regionName } = getSiteLocation();
  const title = type === 'local'
    ? 'Navy Seals Moving | Local & Long Distance Movers in Washington'
    : `Navy Seals Moving | Long Distance Movers from ${regionName}`;
  const description = type === 'local'
    ? 'Family-owned movers serving Washington for over 20 years. Local and long-distance moves handled start to finish by our own professional crews, rated 5 stars by our customers.'
    : `Family-owned long distance moving company with over 20 years of experience. We move families from ${regionName} to anywhere in the U.S., every move handled start to finish by our own professional crews.`;

  return (
    <Fragment>
      <Seo title={title} description={description} />
      <LayoutOne>
        <Titles />
        <Video />
        <WhyChooseUs />
        <Skill />
        <GalleryShort />
      </LayoutOne>
    </Fragment>
  );
};

export default Home;
